import { render, staticRenderFns } from "./checkbox-multi.vue?vue&type=template&id=6fcc8221&"
import script from "./checkbox-multi.vue?vue&type=script&lang=js&"
export * from "./checkbox-multi.vue?vue&type=script&lang=js&"
import style0 from "./checkbox-multi.vue?vue&type=style&index=0&id=6fcc8221&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports